module.exports = __webpack_public_path__ + "img/mobile-county-logo.bf394f6d.jpg";